"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _MiniCompanyHighlight = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/mini/MiniCompanyHighlight"));

var _MiniContactHighlight = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/mini/MiniContactHighlight"));

var _MiniDealHighlight = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/mini/MiniDealHighlight"));

var _MiniTicketHighlight = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/mini/MiniTicketHighlight"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ProfileToIndexButton = _interopRequireDefault(require("crm_ui/profile/common/components/ProfileToIndexButton"));

var _colors = require("HubStyleTokens/colors");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 14px 14px 14px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: sticky;\n  top: 0;\n  opacity: ", ";\n  transition: opacity 200ms cubic-bezier(0.42, 0, 0.58, 1);\n  max-height: ", ";\n  z-index: 2;\n  background-color: ", ";\n  overflow: hidden;\n  height: 72px;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var propTypes = {
  subjectId: _propTypes.default.string.isRequired,
  objectType: _propTypes.default.oneOf([_ObjectTypes.COMPANY, _ObjectTypes.CONTACT, _ObjectTypes.DEAL, _ObjectTypes.TICKET]).isRequired,
  isVisible: _propTypes.default.bool,
  isHiding: _propTypes.default.bool
};

var MiniProfileHighlightWrapper = _styledComponents.default.div.withConfig({
  displayName: "MiniProfileHighlightContainer__MiniProfileHighlightWrapper",
  componentId: "u3ijpr-0"
})(_templateObject(), function (_ref) {
  var isVisible = _ref.isVisible,
      isHiding = _ref.isHiding;
  return !isVisible || isHiding ? 0 : 1;
}, function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? '72px' : 0;
}, _colors.OLAF, _colors.GREAT_WHITE);

var MiniProfileHighlight = _styledComponents.default.div.withConfig({
  displayName: "MiniProfileHighlightContainer__MiniProfileHighlight",
  componentId: "u3ijpr-1"
})(_templateObject2());

var MiniProfileHighlightContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MiniProfileHighlightContainer, _Component);

  function MiniProfileHighlightContainer() {
    (0, _classCallCheck2.default)(this, MiniProfileHighlightContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MiniProfileHighlightContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(MiniProfileHighlightContainer, [{
    key: "getBackButtonComponent",
    value: function getBackButtonComponent() {
      var objectType = this.props.objectType;
      return _react.default.createElement(_ProfileToIndexButton.default, {
        objectType: objectType
      });
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      switch (this.props.objectType) {
        case _ObjectTypes.COMPANY:
          return _MiniCompanyHighlight.default;

        case _ObjectTypes.CONTACT:
          return _MiniContactHighlight.default;

        case _ObjectTypes.DEAL:
          return _MiniDealHighlight.default;

        case _ObjectTypes.TICKET:
          return _MiniTicketHighlight.default;

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          subjectId = _this$props.subjectId,
          isVisible = _this$props.isVisible,
          isHiding = _this$props.isHiding;
      var MiniHighlightComponent = this.getComponent();
      return _react.default.createElement(MiniProfileHighlightWrapper, {
        isVisible: isVisible,
        isHiding: isHiding
      }, _react.default.createElement(MiniProfileHighlight, {
        className: "align-center"
      }, this.getBackButtonComponent(), _react.default.createElement(MiniHighlightComponent, {
        objectType: objectType,
        subjectId: subjectId
      })));
    }
  }]);
  return MiniProfileHighlightContainer;
}(_react.Component);

MiniProfileHighlightContainer.propTypes = propTypes;
var _default = MiniProfileHighlightContainer;
exports.default = _default;
module.exports = exports.default;